import React from "react";
import { Modal } from "antd";
import ScGridTable from "@/components/display/table/gridTableCore";

class LinkModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableConfig: null,
    };
  }

  componentWillMount() {
    this.init();
  }

  init = () => {
    this.setState({
      tableConfig: {
        tableKey: "linkTable",
        tableColumns: [
          {
            name: "方式", // 7'固件型号',
            key: "name",
            colType: "textCol",
            align: "center",
          }, {
            name: "链接", // '设备型号',
            key: "path",
            colType: "textCol",
            align: "center",
            width: 400,
            render: (text) => {
              if (!text || text === "--") {
                return text || "--";
              }
              return <div style={{ whiteSpace: "break-spaces", textAlign: "left" }}>{text}</div>;
            },
          },
        ],
        tableChange: () => {

        },
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.props.sourceList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  render() {
    return (
      <Modal
        title="资源链接"
        visible={this.props.visible}
        onCancel={this.props.onCancel}
        footer={null}
        width={700}
      >
        <ScGridTable config={this.state.tableConfig} />
      </Modal>
    );
  }
}

export default LinkModal;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/linkModal.js